import { range, take } from 'lodash'

export default {
  displayCount: 7,

  pages (active: number, total: number) {
    const pages = range(active, total + 1)
    return take(pages, this.displayCount)
  },

  navigationNumbers (active: number, total: number) {
    return {
      get next () {
        const next = active + 1
        return next >= total ? total : next
      },
      get previous () {
        const previous = active - 1
        return previous < 0 ? active : previous
      }
    }
  }
}
